import { useContext } from 'react';

import PushContext from './PushContext';

const usePush = (throwOnMissingContext = true) => {
  const context = useContext(PushContext);
  if (context === null) {
    if (throwOnMissingContext) {
      throw new Error('usePush must be used within a PushProvider');
    }
    return {};
  }
  return context;
};

export default usePush;
